/* Libraries */
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Grid } from 'ht-styleguide';

/* Components */
import SkuCategoryItems from './SkuCategoryItems';

/* Utils */
import { getUpsellData } from 'src/constants/upsell';

/* Types */
import { SubCategorySlideProps } from '../topNavItems.types';

/* Styles */
import styles from '../topnavitems.module.scss';
import NavSubCategoryUpsell from './NavSubCategoryUpsell';

const SubCategorySlide = ({ subCategory, category, onSecondNavChange }: SubCategorySlideProps) => {
  const upsellData = useMemo(() => getUpsellData({ category: subCategory, device: 'desktop' }), [subCategory]);

  return (
    <>
      <div className={cn(styles.slideHeader, styles.small)}>
        <a
          className={cn(styles.breadcrumb, styles.link)}
          onClick={ev => {
            ev.stopPropagation();
            onSecondNavChange?.();
          }}
        >
          <i className="ht-icon ht-v2-skinny-arrow" /> {category.name}
        </a>
        <a className={styles.breadcrumb}>
          <i className="ht-icon ht-arrow-right " /> {subCategory.name}
        </a>
      </div>
      <hr className={styles.divider} />
      <div className={cn(styles.slideContent, styles.subCategoryContainer)}>
        <Grid.Row>
          <Grid.Column lg={8}>
            <div className={styles.content}>
              <h3 className={styles.title}>{subCategory.name}</h3>
              <Grid.Row>
                {subCategory.types &&
                  subCategory.types.map(subCategoryType => (
                    <Grid.Column lg={6} key={subCategoryType.name}>
                      <div className={styles.typeTitle}>{subCategoryType.name}</div>
                      {subCategoryType.skus && <SkuCategoryItems skus={subCategoryType.skus} variant="secondNav" />}
                    </Grid.Column>
                  ))}
              </Grid.Row>
            </div>
          </Grid.Column>
          <Grid.Column lg={4}>
            <NavSubCategoryUpsell.Desktop {...upsellData} />
          </Grid.Column>
        </Grid.Row>
      </div>
    </>
  );
};

export default React.memo(SubCategorySlide);
